export default "__VITE_ASSET__CnikiA5A__"